
import React from "react";
import { Link } from "react-router-dom";

interface LogoProps {
  isScrolled: boolean;
}

const Logo: React.FC<LogoProps> = ({ isScrolled }) => {
  return (
    <div className="transition-transform duration-200 hover:scale-105 flex items-center">
      <Link to="/" className="flex items-center">
        {isScrolled ? (
          <img 
            src="/lovable-uploads/e77d4bef-26e4-4311-90bc-28a36fffef92.png" 
            alt="Naboo" 
            width="120"
            height="37"
            className="h-6 md:h-8 w-auto grayscale brightness-0"  
          />
        ) : (
          <img 
            src="/lovable-uploads/e77d4bef-26e4-4311-90bc-28a36fffef92.png" 
            alt="Naboo"
            width="120"
            height="37"
            className="h-6 md:h-8 w-auto" 
          />
        )}
      </Link>
    </div>
  );
};

export default Logo;
